<div class="container">

  <ion-button class="close" size="large" fill="clear" color="white" [class.mobile]="isMobile" (click)="close()">
    <ion-icon name="close-circle-outline" slot="icon-only"></ion-icon>
  </ion-button>

  <button class="imageIcon previous" *ngIf="images && images.length > 1" [disabled]="!images || currentIndex === 0" (click)="previousImage()">
      <ion-icon name="caret-back-outline"></ion-icon>
  </button>

  <button class="imageIcon next"  *ngIf="images && images.length > 1" [disabled]="!images || currentIndex === images.length - 1" (click)="nextImage()">
      <ion-icon name="caret-forward-outline"></ion-icon>
  </button>

  <div class="image" *ngIf="type === 'image'">
    <swiper-container
      #swiper
      zoom="true"
      slides-per-view="1"
      centered-slides="true"
      space-between="30"
      (slidechange)="slideChanged($event)">
      <swiper-slide *ngFor="let image of images; let i = index;">
        <div class="swiper-zoom-container">
          <img [src]="image.image">
        </div>
      </swiper-slide>
    </swiper-container>
  </div>

  <div class="video" *ngIf="type === 'video'">
    <swiper-container
      #swiper
      slides-per-view="1"
      centered-slides="true"
      space-between="30"
      (slidechange)="slideChanged($event)">
      <swiper-slide *ngFor="let item of images">
        <video
          controls
          controlsList="nodownload"
          playsinline
          preload="metadata"
          webkit-playsinline="webkit-playsinline"
          class="fullscreen-video">
          <source [src]="item['image'] + '#t=0.1'" />
        </video>
      </swiper-slide>
    </swiper-container>
  </div>
</div>